export default {
    parts: ['container'],
    baseStyle: () => ({
        container: {
            width: '100%'
        }
    })
}
